import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { getSkillsSuggestions } from 'wisestep-api';
import { WsAutoComplete } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

const WsSkillsFilter = ({ name, placeHolder, label = 'Skills' }: WsFilterProps) => {
  const { setValue, getValues } = useFormContext();

  const [skillList, setSkillList] = useState<string[]>([]);
  const onSkillInputKey = async (skillInput: string) => {
    const result = await getSkillsSuggestions(skillInput);
    if (result.data) {
      setSkillList(result.data?.map((item) => item.skill));
    }
  };
  const onSkillSelection = (skillTags: string[]) => {
    setValue('skills', skillTags ?? []);
  };
  return (
    <WsAutoComplete
      onValueEnter={onSkillInputKey}
      onTagsChange={onSkillSelection}
      placeholder={placeHolder}
      initialValue={getValues(name)}
      optionsInStringArray={skillList}
      multiple={true}
      freeSolo={true}
      name={name}
      label={label}
      variant="outlined"
      size="small"
    />
  );
};

export default WsSkillsFilter;
